import { useEffect } from 'react';
import { Box } from '@mui/material';

import { screenSize } from 'Lib/utilities/screenSize';

const StickyWrapper = ({ children, bottom, sticky, customFooter, sx }) => {
	const { mobile: isMobileScreenSize, tablet: isTabletScreenSize } = screenSize();
	const mobile = isTabletScreenSize || isMobileScreenSize;

	useEffect(() => {
		if (document.getElementsByClassName('breadcrumb')[0]) {
			document.getElementsByClassName('breadcrumb')[0].style.borderBottom = 'none';
			document.getElementsByClassName('breadcrumb')[0].style.backgroundColor = 'white';
		}
	});

	if (bottom) {
		return (
			<Box
				className="sticky-header"
				id={customFooter ? 'custom-footer' : ''}
				sx={{
					position: sticky ? 'sticky' : '',
					backgroundColor: 'white',
					bottom: 0,
					gridRowStart: 3,
					borderRadius: '20px',
					zIndex: 9,
					...(customFooter && {
						padding: '10px 10px 0',
						height: '50px'
					}),
					...sx
				}}>
				{children}
			</Box>
		);
	}

	return (
		<Box
			component="header"
			role="banner"
			className="sticky-header"
			id="sticky"
			sx={{
				position: sticky ? 'sticky' : '',
				gridRowStart: 1,
				top: 0,
				left: 0,
				right: 0,
				height: 'fit-content',
				width: mobile ? '100vw' : '100%',
				zIndex: 9,
				...sx
			}}>
			{children}
		</Box>
	);
};

export default StickyWrapper;
